import { defineComponent as _defineComponent } from 'vue'
import LineTagService from "../../services/linetag.service";
import { store } from "@/store";
import { computed, nextTick, ref } from "vue";
import AddToBasketWebRequest = Vertica.LouisPoulsen.Application.Commerce.Requests.AddToBasketWebRequest


export default /*#__PURE__*/_defineComponent({
  __name: 'AddToBasket',
  props: {
    productId: null,
    text: null,
    color: null,
    iconOnly: { type: Boolean },
    quantity: { default: 1 },
    disabled: { type: Boolean },
    allowsCordCutting: { type: Boolean },
    isConfigureable: { type: Boolean },
    buttonClasses: null
  },
  emits: ["added"],
  setup(__props: any, { emit }: { emit: ({(e: "added"): void}), expose: any, slots: any, attrs: any }) {

const props = __props as { productId: string, text?: string, color?: string, iconOnly?: boolean, quantity: number, disabled?: boolean, allowsCordCutting?: boolean, isConfigureable?: boolean, buttonClasses?: string }





const productAddedToCart = ref<boolean>(false);
async function addToBasket(payload: AddToBasketWebRequest) {
    await store.dispatch("basket/addToBasket", payload);
}

const isBasketLocked = computed<boolean>(() => store.getters["basket/isBasketLocked"]);
const variantBeingAdded = computed<string | null>(() => store.getters["basket/variantBeingAdded"]);
const isPrivateMode = computed<boolean>(() => store.getters["app/isPrivateMode"]);

const showCordCuttingModal = ref<boolean>(false);
const cordLength = ref<string>(null);
const serviceProductId = ref<string>(null);

const showSpinner = computed<boolean>(() => {
    if (variantBeingAdded.value === null) { return false; }

    return props.productId === variantBeingAdded.value;
});

async function onAdd() {
    if (props.allowsCordCutting) {
        showCordCuttingModal.value = true;
    } else {
        addProductInternal();
    }
}

function toggleBasket() : void {
    store.dispatch("navigation/toggleBasket");
}

async function addToBasketRequest(): Promise<AddToBasketWebRequest> {
    const request: AddToBasketWebRequest = {
        id: props.productId,
        quantity: props.quantity,
        reference: null,
        basketType: null,
        cordLength: cordLength.value,
        serviceProductId: serviceProductId.value,
        discountPercent: null,
        customConfiguration: null
    };

    if (props.isConfigureable) {
        const expiviConfig = await window.expivi.saveConfiguration(596,596); // thumbnail image size 596 x 596 is set from basket page requirements
        const expiviAttributes = expiviConfig.configured_products[0].attributes || [];
        const expiviNameValues = expiviAttributes.map((a: any) => ({
            name: a.attribute_name,
            value: a.attribute_value_name
        }));
        request.customConfiguration =        {
            attributes: expiviNameValues,
            thumbnail: expiviConfig.configured_products[0].thumbnail,
        };
    }

    return request;
}

function addWithCordCutting(serviceProduct: string = null, length: string = null) {
    cordLength.value = length || null;
    serviceProductId.value = serviceProduct || null;
    addProductInternal();
}

async function addProductInternal() {
    await addToBasket(await addToBasketRequest());

    cordLength.value = null;
    serviceProductId.value = null;
    emit("added");
    productAddedToCart.value = true;
    if (isPrivateMode.value) {
        toggleBasket();
    }

    nextTick(() => {
        setTimeout(() => {
            productAddedToCart.value = false;
        }, 2000);
    });
    LineTagService.trackAddCart();
}

return { __sfc: true,props, emit, productAddedToCart, addToBasket, isBasketLocked, variantBeingAdded, isPrivateMode, showCordCuttingModal, cordLength, serviceProductId, showSpinner, onAdd, toggleBasket, addToBasketRequest, addWithCordCutting, addProductInternal }
}

})